import React, { forwardRef } from "react";

export type SvgComp = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export type SvgImgProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src"
> & {
  src: SvgComp; // SVGR component instead of URL
};

export const SvgImageSwap = forwardRef<HTMLSpanElement, SvgImgProps>(
  (
    { src: Svg, alt, className, style, width, height, ...imgLikeProps },
    ref,
  ) => {
    // Remove <SvgImageSwap>-only attributes so React doesn't warn
    const {
      crossOrigin,
      decoding,
      fetchPriority,
      loading,
      referrerPolicy,
      sizes,
      srcSet,
      useMap,
      ...spanProps
    } = imgLikeProps as any;

    return (
      <span
        ref={ref}
        {...spanProps}
        role={alt ? "icon" : "presentation"}
        aria-label={alt || undefined}
        style={{ display: "inline-flex", ...style }}
      >
        <Svg
          className={className}
          width={width as any}
          height={height as any}
          aria-hidden={alt ? undefined : true}
          focusable="false"
        />
      </span>
    );
  },
);
